import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DataTable from '../../../../components/DataTable/DataTable';
import { useGetAllPurchases } from '../../hooks/api/purchasesApi';
import DataTableBodyCellIcon from '../../../../components/DataTable/DataTableBody/DataTableBodyCell/DataTableBodyCellIcon';
import DataTableRowHoverButton from '../../../../components/DataTable/DataTableBody/DataTableBodyCell/DataTableRowHoverButton';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { commodities } from '../../../../constants/commodities';

const initialValues = {
  order: 'desc',
  orderBy: 'purchaseDate',
};

const ButtonWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const columns = [
  {
    id: 'purchaseDate',
    label: <FormattedMessage id={'app.lastPurchaseSteps.purchaseDate'} />,
    align: 'right',
    options: {
      sortable: true,
    },
  },
  {
    id: 'contractName',
    label: <FormattedMessage id={'app.lastPurchaseSteps.contractName'} />,
  },
  {
    id: 'product',
    label: <FormattedMessage id={'app.lastPurchaseSteps.product'} />,
  },
  {
    id: 'purchaseType',
    label: <FormattedMessage id={'app.lastPurchaseSteps.purchaseType'} />,
  },
  {
    id: 'exchangeRate',
    label: <FormattedMessage id={'app.lastPurchaseSteps.exchangeRate'} />,
    align: 'right',
  },
  {
    id: 'stockPrice',
    label: <FormattedMessage id={'app.lastPurchaseSteps.stockPrice'} />,
    align: 'right',
  },
  {
    id: 'amount',
    label: <FormattedMessage id={'app.lastPurchaseSteps.amount'} />,
    align: 'right',
  },
  {
    id: 'submitter',
    label: <FormattedMessage id={'app.lastPurchaseSteps.submitter'} />,
  },
  {
    id: 'controls',
    label: '',
  },
];

const contractDetail = 'contract';
const contractDetailBuyTab = 'buy';

const PurchasesList = ({ customerId }) => {
  const [tableData, setTableData] = useState([]);
  const [orderDirection, setOrderDirection] = useState(initialValues.order);
  const [orderByColumn, setOrderByColumn] = useState(initialValues.orderBy);

  const { getAllTransactions, error, loading, data } = useGetAllPurchases();
  const history = useHistory();

  useEffect(() => {
    const query = {
      sort: {
        type: orderDirection,
        column: orderByColumn,
      },
      filters: [
        {
          column: 'organizationId',
          values: [customerId],
        },
      ],
    };
    (async () => {
      await getAllTransactions(query);
    })();
  }, [getAllTransactions, orderDirection, orderByColumn, customerId]);

  useEffect(() => {
    if (data) {
      const output = data.data.map((line) => {
        const icon = commodities?.[line?.contract.commodity.id]?.icon || null;

        return {
          purchaseDate: <FormattedDate value={line?.createdAt} />,
          contractName: <DataTableBodyCellIcon icon={icon} text={`${line.contract?.commodity?.name} ${line.contract?.contractPeriod}`} />,
          product: line.exchangeProduct?.name,
          purchaseType: line.purchaseType?.name,
          supplyPeriod: line.supplyPeriod,
          exchangeRate: line.rate,
          stockPrice: <FormattedNumber value={line.price} />,
          amount: <FormattedNumber value={line.quantity} />,
          submitter: `${line.user?.firstname} ${line.user?.surname}`,
          controls: (
            <DataTableRowHoverButton>
              <ButtonWrapper
                onClick={() => {
                  history.push(`/${contractDetail}/${line.contract?.id}/${contractDetailBuyTab}`, {
                    product: line.exchangeProduct?.id,
                    quantity: line.quantity,
                  });
                }}>
                <ShoppingCartIcon /> <FormattedMessage id={'app.repeatPurchase'} />
              </ButtonWrapper>
            </DataTableRowHoverButton>
          ),
        };
      });

      setTableData(output);
    }
  }, [data, history]);

  return (
    <DataTable
      displayToolbar={false}
      displayPagination={false}
      lineHover
      columns={columns}
      data={tableData || []}
      loading={loading}
      error={error}
      orderDirection={orderDirection}
      setOrderDirection={setOrderDirection}
      orderByColumn={orderByColumn}
      setOrderByColumn={setOrderByColumn}
    />
  );
};

PurchasesList.propTypes = {
  customerId: PropTypes.number,
};

export default PurchasesList;
